export function setCrashlyticsUserId(_uid: string | null) {
  // Firebase Crashlytics is native-only. The web bundle uses Firebase Analytics
  // and browser console reporting instead.
}

export function setCrashlyticsRoute(_pathname: string) {
  // Firebase Crashlytics is native-only.
}

export function recordCrashlyticsError(_error: unknown, _context?: string) {
  // Firebase Crashlytics is native-only.
}
